import React from 'react';
import { Button } from './ui/button';

const FeaturesSection = ({ property }) => {
  const features = [
    {
      number: '01',
      title: 'Spacious & Comfortable',
      description: 'Newly renovated with a super king bed, cozy sitting room with sofa bed, and modern bathroom. Perfect for couples or small families.',
    },
    {
      number: '02',
      title: 'Fully Equipped',
      description: 'Everything you need: kitchen with Nespresso machine, dishwasher, washing machine, Smart TVs, fast WiFi, and your own parking space.',
    },
    {
      number: '03',
      title: 'Beautiful Surroundings',
      description: 'Stunning countryside views, acres of garden to explore, and complete peace and quiet.',
    },
    {
      number: '04',
      title: 'Perfectly Located',
      description: '15 minutes to Gatwick Airport, easy access to Brighton beach, charming village pubs, and lovely walking routes.',
    },
  ];

  return (
    <div className="bg-card/60 py-16 md:py-20">
      <div className="max-w-[1120px] mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-primary mb-4" style={{fontFamily: 'Cormorant Garamond, Georgia, serif'}}>
            Why Stay With Us
          </h2>
          <p className="text-base md:text-lg text-accent max-w-2xl mx-auto font-medium">
            Everything you need for a peaceful getaway
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
          {features.map((feature) => (
            <div 
              key={feature.number}
              className="bg-background border-2 border-border rounded-xl md:rounded-2xl p-6 md:p-8 hover:shadow-lg hover:border-primary/30 transition-all"
            >
              <div className="flex items-start gap-4 md:gap-6">
                <div className="text-4xl md:text-5xl font-bold text-primary/20" style={{fontFamily: 'Cormorant Garamond, Georgia, serif'}}>
                  {feature.number}
                </div>
                <div className="flex-1">
                  <h3 className="text-xl md:text-2xl font-semibold mb-2 md:mb-3 text-accent" style={{fontFamily: 'Cormorant Garamond, Georgia, serif'}}>
                    {feature.title}
                  </h3>
                  <p className="text-sm md:text-base text-muted-foreground leading-relaxed">
                    {feature.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Pricing - consistent styling */}
        <div className="mt-12 text-center">
          <div className="inline-block bg-background border-2 border-primary/30 rounded-xl md:rounded-2xl px-8 md:px-10 py-6 md:py-8 shadow-md">
            <div className="text-xs md:text-sm text-muted-foreground mb-2 uppercase tracking-wider">From</div>
            <div className="text-4xl md:text-5xl font-bold text-accent" style={{fontFamily: 'Cormorant Garamond, Georgia, serif'}}>
              £{property.pricing.nightlyRate}
            </div>
            <div className="text-xs md:text-sm text-muted-foreground mt-2">per night</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeaturesSection;